<template>
  <div>
    <div class="app-content content">
      <div class="content-overlay"></div>
      <div class="content-wrapper">
        <div class="content-header row"></div>
        <div class="content-body">
          <!-- login page start -->
          <section id="auth-login" class="row flexbox-container">
            <div class="col-xl-8 col-11">
              <div class="card bg-authentication mb-0">
                <div class="row m-0">
                  <!-- left section-login -->
                  <div class="col-md-6 col-12 px-0">
                    <div
                      class="card disable-rounded-right mb-0 p-2 h-100 d-flex justify-content-center"
                    >
                      <div class="card-header pb-1">
                        <div class="text-center">
                          <h2>
                            <img
                              src="@/app-assets/images/brand/pacto-logo.png"
                              alt="Pacto Logo"
                              style="width: 160px"
                            />
                          </h2>
                        </div>
                      </div>
                      <div class="card-content">
                        <div class="card-body">
                          <div class="divider">
                            <div class="divider-text text-uppercase text-muted">
                              <small>Login with your credentials</small>
                            </div>
                          </div>
                          <div class="text-center" v-if="loginError">
                            <p class="error">Incorrect email or password 😕</p>
                          </div>
                          <form
                            action="#"
                            :class="{ 'form-group--error': v$.email.$error }"
                          >
                            <div class="form-group mb-50">
                              <label class="text-bold-600" for="emailInput"
                                >Email address</label
                              >
                              <input
                                type="email"
                                class="form-control"
                                id="emailInput"
                                placeholder="Email address"
                                v-model.trim="v$.email.$model"
                              />
                              <small
                                class="error"
                                v-if="!v$.email.required && submitStatus"
                                >Email address is required</small
                              >
                            </div>
                            <div class="form-group">
                              <label class="text-bold-600" for="passwordInput"
                                >Password</label
                              >
                              <input
                                type="password"
                                class="form-control"
                                id="passwordInput"
                                placeholder="Password"
                                v-model.trim="v$.password.$model"
                              />
                              <small
                                class="error"
                                v-if="!v$.password.required && submitStatus"
                                >Password is required</small
                              >
                            </div>
                            <div
                              class="form-group d-flex flex-md-row flex-column justify-content-between align-items-center"
                            >
                              <div class="text-right">
                                <router-link
                                  :to="{ name: 'ForgotPassword' }"
                                  class="card-link"
                                  ><small>Forgot Password?</small></router-link
                                >
                              </div>
                              <div class="text-right">
                                <router-link
                                  :to="{ name: 'SignupPage' }"
                                  class="card-link"
                                  ><small
                                    >Don't have an account? Sign Up</small
                                  ></router-link
                                >
                              </div>
                            </div>
                            <button
                              @click="login()"
                              type="button"
                              class="btn btn-primary glow w-100 position-relative"
                              v-if="!loggingIn"
                            >
                              Login<em
                                id="icon-arrow"
                                class="bx bx-right-arrow-alt"
                              ></em>
                            </button>
                            <button
                              disabled
                              type="button"
                              class="btn btn-primary glow w-100 position-relative"
                              v-else
                            >
                              <span
                                class="spinner-border spinner-border-sm"
                                role="status"
                                aria-hidden="true"
                              ></span>
                              <span class="sr-only">Loading...</span>
                            </button>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- right section image -->
                  <div
                    class="col-md-6 d-md-block d-none text-center align-self-center p-3"
                  >
                    <div class="card-content">
                      <lottie-player
                        src="https://assets4.lottiefiles.com/packages/lf20_fwykef3x.json"
                        background="transparent"
                        speed="1"
                        style="width: 100%; height: auto"
                        loop
                        autoplay
                      ></lottie-player>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <!-- login page ends -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/app-assets/css/pages/authentication.css";
import { useVuelidate } from '@vuelidate/core'
import { required, email } from '@vuelidate/validators';
export default {
  setup () {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      email: "",
      password: "",
      loggingIn: false,
      submitStatus: false,
      loginError: false,
    };
  },

  methods: {
    login() {
      let self = this;
      this.v$.$touch();
      this.submitStatus = true;
      if (!this.v$.$invalid) {
        this.loggingIn = true;
        this.loginError = false;
        this.$apiCall
          .post("/v1/auth/login", {
            email: self.email,
            password: self.password,
          })
          .then(function (response) {
            self.$store.dispatch("currentUser/loginUser", response);
          })
          .catch(function (error) {
            self.loginError = true;
            self.loggingIn = false;
            self.v$.email.$model = "";
            self.v$.password.$model = "";
          });
      } else {
        this.loggingIn = false;
        this.loginError = false;
      }
    },
  },

  mounted() {
    $("body").removeClass(
      "vertical-layout vertical-menu-modern 2-columns navbar-sticky footer-static"
    );
    $("body").addClass(
      "vertical-layout vertical-menu-modern 1-column navbar-sticky footer-static bg-full-screen-image blank-page blank-page"
    );
  },

  validations: {
    email: {
      required,
      email,
    },
    password: {
      required,
    },
  },
};
</script>

<style scoped>
.error {
  color: red;
}
</style>    